module.exports = __webpack_public_path__ + "static/media/ly.5357907b.svg";